// extracted by css-extract-rspack-plugin
export default {"cls1":"ButtonsPage-cls1_QtX","cls2":"ButtonsPage-cls2_UlX ButtonsPage-cls1_QtX","withThumbnail":"ButtonsPage-withThumbnail_0BA"};